import { render, staticRenderFns } from "./upload-catalogue.vue?vue&type=template&id=09de2500&scoped=true"
import script from "./upload-catalogue.vue?vue&type=script&lang=js"
export * from "./upload-catalogue.vue?vue&type=script&lang=js"
import style0 from "./upload-catalogue.vue?vue&type=style&index=0&id=09de2500&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09de2500",
  null
  
)

export default component.exports